import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import { startCall } from './api';
import PhoneLink from 'components/click_to_call/phone_link';

import { isPresent } from 'helpers/string_helpers';

export default class CallContactLink extends React.Component {
  static propTypes = {
    fax: PropTypes.bool,
    phone: PropTypes.string,
    phoneNormalized: PropTypes.string,
    targetName: PropTypes.string,
    user: PropTypes.shape({
      clickToCallEnabled: PropTypes.bool.isRequired,
      clickToCallRegistrationComplete: PropTypes.bool.isRequired,
      userIsAssumed: PropTypes.bool.isRequired
    }).isRequired
  };

  state = {
    callStatus: '',
    registrationComplete: this.props.user.clickToCallRegistrationComplete,
    showCallStatusModal: false,
    showInstallModal: false
  };

  callStatusAlert = (message) => {
    this.setState({
      callStatus: message,
      showCallStatusModal: true
    });
  };

  clickToCallEnabled = () => {
    const { phoneNormalized, user } = this.props;
    return user.clickToCallEnabled && isPresent(phoneNormalized);
  };

  handleClick = () => {
    const { phoneNormalized, targetName, user } = this.props;
    const { registrationComplete } = this.state;

    if (isPresent(phoneNormalized)) {
      if (user.userIsAssumed) {
        this.callStatusAlert('Click-to-call is restricted when assuming another user.');
      } else if (user.clickToCallEnabled && registrationComplete) {
        const name = targetName || phoneNormalized;
        startCall(name, phoneNormalized).then(
          response =>  this.callStatusAlert(response.message),
          () =>  this.callStatusAlert('There was a problem calling you - please try again later.')
        );
      } else {
        this.setState({ showInstallModal: true });
      }
    }
  };

  handleCloseCallStatusModal = () => this.setState({ showCallStatusModal: false });

  handleRegistrationModalClose = () => {
    this.setState({
      showInstallModal: false
    });
  };

  navigateToIntegrations() {
    window.location.assign('/profile_settings#integrationsTab');
  }

  render() {
    const { fax, phone } = this.props;

    return (
      <React.Fragment>
        <PhoneLink
          disabled={!this.clickToCallEnabled()}
          fax={fax}
          phone={phone}
          onClick={this.handleClick}
        />
        {this.renderInstallModal()}
        {this.renderCallStatusModal()}
      </React.Fragment>
    );
  }

  renderInstallModal() {
    const { user } = this.props;

    if (!(this.state.registrationComplete || user.userIsAssumed)) {
      return (
        <Modal
          name="install-call-modal"
          show={this.state.showInstallModal}
          onClose={this.handleRegistrationModalClose}
        >
          <Modal.Header>
            <Modal.Title>Install Call from Buildout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Integrate click-to-call on your Profile.</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-cancel" type="button" onClick={this.handleRegistrationModalClose}>
              Cancel
            </button>
            <button className="btn btn-primary" type="button" onClick={this.navigateToIntegrations}>
              OK
            </button>
          </Modal.Footer>
        </Modal>
      );
    }
  }

  renderCallStatusModal() {
    return (
      <Modal show={this.state.showCallStatusModal} onCancel={this.handleCloseCallStatusModal}>
        <Modal.Header>
          <Modal.Title>Call Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{this.state.callStatus}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            name="ok-button"
            onClick={this.handleCloseCallStatusModal}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
